import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { IndustriesOrSectorsEffects } from './industries-or-sectors.effects';
import { STORE_TYPE } from './industries-or-sectors.model';
import { industriesOrSectorsReducer } from './industries-or-sectors.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(STORE_TYPE, industriesOrSectorsReducer),
    EffectsModule.forFeature([IndustriesOrSectorsEffects]),
  ],
})
export class UIIndustriesOrSectorsStoreModule {}
